import { CmStreamingFormat } from '../cta/CmStreamingFormat.js';

/**
 * Common Media Client Data Streaming Format
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */
export const CmcdStreamingFormat = CmStreamingFormat as typeof CmStreamingFormat;

/**
 * @beta
 */
export type CmcdStreamingFormat = CmStreamingFormat
